function coopDragNDrop() {
	// Nodes
	const form = document.querySelector('.cooperation__form')
	if (!form) return
	const label = form.querySelector('.form-label')
	const placeholder = label.querySelector('span')
	const fileInput = label.querySelector('[type="file"]')

	// Proxy state
	const state = {
		over: false,
		loaded: false,
	}

	const handler = {
		get(target, key) {
			return Reflect.get(target, key)
		},
		set(target, key, val) {
			if (key === 'loaded') {
				if (val) {
					label.classList.add('form-label--added')
					placeholder.style = 'display: none;'
				} else {
					label.classList.remove('form-label--added')
					placeholder.style = ''
				}
			}

			return Reflect.set(target, key, val)
		},
	}

	const proxyState = new Proxy(state, handler)

	let filesHtml

	// Drop handle
	form.addEventListener('drop', e => {
		e.preventDefault()

		let files = [...e.dataTransfer.files]

		uploadFile(files)
	})

	label.onchange = e => {
		let files = [...e.target.files]
		uploadFile(files)
	}

	// For drag n drop
	form.addEventListener('dragstart', e => {
		e.preventDefault()
		e.stopPropagation()
		proxyState.over = true
	})
	form.addEventListener('dragleave', e => {
		e.preventDefault()
		e.stopPropagation()
		proxyState.over = false
	})
	form.addEventListener('dragover', e => {
		e.preventDefault()
		e.stopPropagation()
		proxyState.over = true
	})

	function uploadFile(files) {
		const oldFiles = label.querySelectorAll('& > div')
		if (oldFiles.length) {
			oldFiles.forEach(f => f.remove())
			fileInput.value = ''
		}
		proxyState.loaded = true

		for (let file of files) {
			label.insertAdjacentHTML('beforeend', addFile(file.name))
		}

		filesHtml = label.querySelectorAll('.file')

		filesHtml.forEach(file => {
			const close = file.querySelector('.file__remove')
			const name = file.querySelector('.file__name').textContent

			close.onclick = e => {
				e.stopPropagation()
				e.preventDefault()
				files = files.filter(f => f.name !== name)
				file.remove()

				if (!files.length) {
					fileInput.value = ''
					proxyState.loaded = false
				}
			}
		})
	}
}

function addFile(name) {
	return `
        <div class="form-label__file file">
            <div class="file__inner">
                <img class="file__img" src="img/empty-file.png">
                <span class="file__name">${name}</span>
            </div>
            <span class="file__remove">Удалить</span>
        </div>
    `
}

function sendForm(form) {
	const fields = form.querySelectorAll('input[name]')

	const popups = {
		success: document.querySelector('#successful-send'),
		error: document.querySelector('#error-send'),
	}

	const showPopup = 'display: flex; background-color: #fff; border-radius: 10px; box-shadow: 0px 0px 12px 10px rgba(34, 60, 80, 0.2); position: fixed; z-index: 99; top: 50%; left: 50%; transform: translate(-50%, -50%);'

	fetch(form.action, {
		method: 'POST',
		body: data(fields, form),
	})
		.catch(err => {
			popups.error.style = showPopup
			// $.fancybox.open(popups.error)
		})
		.then(res => res.json())
		.then(data => {
			if (statusChecker(data.status)) {
				popups.success.style = showPopup
				// $.fancybox.open(popups.success)
			} else {
				popups.error.style = showPopup
				// $.fancybox.open(popups.error)
			}
		})
		.finally(() => {
			setTimeout(() => {
				for (const key in popups) {
					popups[key].style = 'display: none;'
				}
			}, 2000)
		})
}